import { SelectField, SelectFieldProps } from 'components/form'
import { CaracteristicaLesaoEnum } from 'graphql/types.generated'
import React from 'react'

import { getTecidosMolesCaracteristicaLesao, getTipoCaracteristicaLesao, TipoCaracteristicaLesao } from '../../../model'

export interface SuperficieTecidosMolesFieldModel {
  value: CaracteristicaLesaoEnum
  label: string
}

export interface SuperficieTecidosMolesFieldProps
  extends Omit<SelectFieldProps<SuperficieTecidosMolesFieldModel>, 'label' | 'itemToString' | 'items'> {}

const superficie = getTipoCaracteristicaLesao(TipoCaracteristicaLesao.SUPERFICIE)

const items = superficie.items
  .map(
    (item) =>
      ({
        label: getTecidosMolesCaracteristicaLesao(item).title,
        value: item,
      } as SuperficieTecidosMolesFieldModel)
  )
  .sort((a, b) => a.label.localeCompare(b.label))

export default function SuperficieTecidosMolesField(props: SuperficieTecidosMolesFieldProps) {
  return <SelectField label={superficie.title} items={items} itemToString={(i) => i?.label} {...props} />
}
